import { api } from '@cwd/lib/main';

export interface LatestSms {
    Ended: string | null;
    Sender: string;
    Subject: string;
    Body: string;
    RecipientCount: number;
    LastModifiedByFirstName: string;
    LastModifiedByLastName: string;
    AccountName: string;
}

export async function getLatestSms(): Promise<LatestSms[]> {
    return api.get('/BackOffice/LatestSms');
}
